import React, { useState } from "react";
import DoctorCard from "./DoctorCard";
import FiltersRow from "../FiltersRow/FiltersRow";

const Cards = ({data, services, bottom, totalPages}) => {
  const [page, setPage] = useState(1);
  const [service, setService] = useState('');
  const [doctors, setDoctors] = useState(data);
  const [pages, setPages] = useState(totalPages);
  const ordered_services = new Map(services.map((s, i) => [i, s]));

  const url = '/doctors';
  const axios = require('axios');
  axios.defaults.headers.common['Accept'] = 'application/json';

  const handleSubmit = e => {
    e.preventDefault();

    axios.get(url, {
      params: { page: page + 1, service: service }
    }, {headers: {'Content-Type': 'text/javascript'}})
    .then(function (response) {
      setDoctors([...doctors, ...response.data.doctors]);
      setPage(page + 1);
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  const handleFilter = currentIndex => {
    const selected = ordered_services.get(currentIndex);
    axios.get(url, {
      params: { service: selected }
    }, {headers: {'Content-Type': 'text/javascript'}})
    .then(function (response) {
      setDoctors(response.data.doctors);
      setPages(response.data.pages);
      setService(selected);
      setPage(1);
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  return (
    <div>
      <FiltersRow handleFilter={handleFilter} services={ordered_services} bottom={bottom} />
      <div className="doctors-list">
        {doctors.map((element, index) => (
          <DoctorCard
           key={index}
           size='small'
           lastName={element.lastName}
           firstName={element.firstName}
           description={element.description}
           photo={element.photo}
           appointmentLink={element.appointmentLink}
           doctorLink={element.doctorLink}
          />
        ))}
      </div>
      { page < pages &&
        <div className="doctors-page-button-container animation-waypoint animation-trigger">
          <a className="button button_large doctors-page__button" onClick={handleSubmit} rel="next">Показать еще</a>
        </div>
      }
      {doctors.length == 0 &&
        <div className='doctors-page__no-results'>Нет результатов</div>
      }
    </div>
  )

};

export default Cards;
